import React, { Component } from "react";
import { getInsights } from "../../actions/financials";

class Insights extends Component {
  constructor() {
    super();
    this.state = {
      upi: {},
      card: {},
      netBanking: {},
      wallet: {},
      payLater: {},
      IOS: {},
    };
  }

  componentDidMount() {
    getInsights()
      .then((res) => {
        return res.response.payment_insights;
      })
      .then((res) => {
        console.log("ewa", res);
        res.map((list) => {
          if (list._id === "upi") {
            this.setState({ upi: list });
          }
          if (list._id === "wallet") {
            this.setState({ wallet: list });
          }
          if (list._id === "netbanking") {
            this.setState({ netBanking: list });
          }
          if (list._id === "paylater") {
            this.setState({ payLater: list });
          }
          if (list._id === "card") {
            this.setState({ card: list });
          }
          if (list._id === "IAP_IOS") {
            this.setState({ IOS: list });
          }
        });
      });
  }

  render() {
    const { upi, card, netBanking, wallet, payLater, IOS } = this.state;
    return (
      <div style={{"backgroundColor":"white"}}>
        <table className="newTable margin" style={{"width":"70%"}}>
        <thead>
          <tr>
            <th>Mode Of Payment</th>
            <th>Total Amount (Rs.) </th>
            <th>Total Payments</th>
            <th>Tax (Rs.)</th>
            <th>Fee (Rs.)</th>
          </tr>
          </thead>
          <tr>
            <td>Pay Later</td>
            <td>{payLater.totalAmount / 100}</td>
            <td>{payLater.totalPayments}</td>
            <td>{payLater.tax / 100}</td>
            <td>{payLater.fee / 100}</td>
          </tr>
          <tr>
            <td>Net Banking</td>
            <td>{netBanking.totalAmount / 100}</td>
            <td>{netBanking.totalPayments}</td>
            <td>{netBanking.tax / 100}</td>
            <td>{netBanking.fee / 100}</td>
          </tr>
          <tr>
            <td>UPI</td>
            <td>{upi.totalAmount / 100}</td>
            <td>{upi.totalPayments}</td>
            <td>{upi.tax / 100}</td>
            <td>{upi.fee / 100}</td>
          </tr>
          <tr>
            <td>Card</td>
            <td>{card.totalAmount / 100}</td>
            <td>{card.totalPayments}</td>
            <td>{card.tax / 100}</td>
            <td>{card.fee / 100}</td>
          </tr>
          <tr>
            <td>Wallet</td>
            <td>{wallet.totalAmount / 100}</td>
            <td>{wallet.totalPayments}</td>
            <td>{wallet.tax / 100}</td>
            <td>{wallet.fee / 100}</td>
          </tr>
          <tr>
            <td>IOS</td>
            <td>{IOS.totalAmount / 100}</td>
            <td>{IOS.totalPayments}</td>
            <td>{IOS.tax / 100}</td>
            <td>{IOS.fee / 100}</td>
          </tr>
        </table>
      </div>
    );
  }
}

export default Insights;
